import React, { Suspense, useEffect, useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import { Input, SubTitle } from "../../Components/CustomComponents/index.js";
import Table from "../../Components/Table/Table.js";
import Toast, { SuccessToast } from "../../Hooks/useToast.js";
import styles from "./styles/user_management.module.scss";
// import { ToastContainer, toast } from "react-toastify";

import { useDispatch } from "react-redux"; // for getting and setting data into local redux
// import CustomerBlockModal from "../../Components/Modals/CustomerBlockModal";
import { Col, Row, Spinner } from "react-bootstrap";
import { CgDetailsMore } from "react-icons/cg";
import DeleteModal from "../../Components/Modals/DeleteModal.js";
// import EditBusinessTypeModal from "../../Components/Modals/EditBusinessTypeModal.js";
import { MdCancel } from "react-icons/md";
import { FaCircleCheck } from "react-icons/fa6";
import ToolTip from "../../Components/CustomComponents/ToolTip.js";
import UserAvatar from "../../Components/CustomComponents/UserAvatar.js";
import ShopDetailsModal from "../../Components/Modals/ShopDetailsModal.js";
import {
  useDeleteQuestionMutation,
  useGetAllQuestionQuery,
} from "../../Data/services/questionApi.js";
import moment from "moment/moment.js";
import CustomBadge from "../../Components/Badges/CustomBadge.js";
import OrderDetailsModal from "../../Components/Modals/OrderDetailsModal.js";
import { Controller, useForm } from "react-hook-form";
import SelectFieldComponent from "../../Components/CustomComponents/SelectFieldComponent.js";
import _ from "lodash";

const ProductManagementScreen = ({ setPage }) => {
  const { control, watch } = useForm({
    defaultValues: {
      status: "",
    },
  });

  const status = watch("status");
  console.log(status);

  const dispatch = useDispatch();

  // const [data, setData] = useState([]);
  const [indicationMessage, setIndicationMessage] = useState("loading...");
  const [rowData, setRowData] = useState([]);
  const [editedData, setEditedData] = useState("");

  const [loading, setLoading] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  const [currentPage, setCurrentPage] = useState(1); // todo
  const [pageSize, setPageSize] = useState(10); // todo
  const [totalRecords, setTotalRecords] = useState(0); // todo
  const [totalPages, setTotalPages] = useState(0); // todo
  const [dataFetched, setDataFetched] = useState(false); // todo

  const [searchQuery, setSearchQuery] = useState("");

  // MARK: Dummy Data

  const dummyData = {
    data: [
      {
        id: 71,
        slug: "cdcbb5d1-48c3-4166-8b6c-3efcef7c8fa2",
        rider_slug: "fad8063d-f6cf-4499-8dce-6c149efe89e8",
        user_slug: "36230b8f-1e57-4d52-b2e6-e824810f8807",
        vendor_slug: "21cd47e5-9a4c-4f32-93ad-dc6acc1653c2",
        owner_type: "CUSTOMER",
        delivery_location:
          "3rd Floor, Delhi Mercantile Society, Karachi, Sindh, , Pakistan, 3rd Floor, 2 floor",
        latitude: "24.878",
        longitude: "67.0686",
        delivery_charges: 10,
        platform_fee: 5,
        subtotal: 12,
        total_amount: 27,
        status: "DELIVERED",
        vendor: {
          image_url:
            "http://api.bibo.trangotechdevs.com:3012/1731923649651.octet-stream",
          slug: "21cd47e5-9a4c-4f32-93ad-dc6acc1653c2",
          firstname: null,
          lastname: null,
          name: "shop twelve",
          email: "shop12@yopmail.com",
          user_type: "SHOP_OWNER",
          latitude: "24.87790",
          longitude: "67.06860",
          mobile_no: "+11212121212",
        },
        user: {
          image_url:
            "http://api.bibo.trangotechdevs.com:3012/user-placeholder.jpeg",
          slug: "36230b8f-1e57-4d52-b2e6-e824810f8807",
          firstname: "customer",
          lastname: "one",
          name: null,
          email: "customer1@yopmail.com",
          user_type: "CUSTOMER",
          latitude: null,
          longitude: null,
          mobile_no: "+11234657971",
        },
        rider: {
          image_url:
            "http://api.bibo.trangotechdevs.com:3012/user-placeholder.jpeg",
          slug: "fad8063d-f6cf-4499-8dce-6c149efe89e8",
          firstname: "rider",
          lastname: "user",
          name: null,
          email: "rideruser@yopmail.com",
          user_type: "RIDER",
          latitude: "24.8780313",
          longitude: "67.0687139",
          mobile_no: "+11234567896",
        },
        order_items_count: 1,
        created_at: "2024-11-27T08:24:59.000Z",
      },
      {
        id: 70,
        slug: "2278ddde-9d4e-47e6-a6fd-cabdc433cbb1",
        rider_slug: "fad8063d-f6cf-4499-8dce-6c149efe89e8",
        user_slug: "36230b8f-1e57-4d52-b2e6-e824810f8807",
        vendor_slug: "21cd47e5-9a4c-4f32-93ad-dc6acc1653c2",
        owner_type: "CUSTOMER",
        delivery_location:
          "3rd Floor, Delhi Mercantile Society, Karachi, Sindh, , Pakistan, 3rd Floor, 2 floor",
        latitude: "24.878",
        longitude: "67.0686",
        delivery_charges: 10,
        platform_fee: 5,
        subtotal: 12,
        total_amount: 27,
        status: "DELIVERED",
        vendor: {
          image_url:
            "http://api.bibo.trangotechdevs.com:3012/1731923649651.octet-stream",
          slug: "21cd47e5-9a4c-4f32-93ad-dc6acc1653c2",
          firstname: null,
          lastname: null,
          name: "shop twelve",
          email: "shop12@yopmail.com",
          user_type: "SHOP_OWNER",
          latitude: "24.87790",
          longitude: "67.06860",
          mobile_no: "+11212121212",
        },
        user: {
          image_url:
            "http://api.bibo.trangotechdevs.com:3012/user-placeholder.jpeg",
          slug: "36230b8f-1e57-4d52-b2e6-e824810f8807",
          firstname: "customer",
          lastname: "one",
          name: null,
          email: "customer1@yopmail.com",
          user_type: "CUSTOMER",
          latitude: null,
          longitude: null,
          mobile_no: "+11234657971",
        },
        rider: {
          image_url:
            "http://api.bibo.trangotechdevs.com:3012/user-placeholder.jpeg",
          slug: "fad8063d-f6cf-4499-8dce-6c149efe89e8",
          firstname: "rider",
          lastname: "user",
          name: null,
          email: "rideruser@yopmail.com",
          user_type: "RIDER",
          latitude: "24.8780313",
          longitude: "67.0687139",
          mobile_no: "+11234567896",
        },
        order_items_count: 1,
        created_at: "2024-11-27T07:50:57.000Z",
      },
      {
        id: 68,
        slug: "42824e6a-4358-458a-be3a-7e029b24f68f",
        rider_slug: "4a0abdf8-b70e-40bf-8c6a-294919e902d9",
        user_slug: "a19c9a6d-6468-4813-b667-15b3a863afa7",
        vendor_slug: "21cd47e5-9a4c-4f32-93ad-dc6acc1653c2",
        owner_type: "CUSTOMER",
        delivery_location:
          "Siraj ud Dula Road, , Karachi, Sindh, , Pakistan, Siraj ud Dula Road, etg",
        latitude: "24.8781",
        longitude: "67.0683",
        delivery_charges: 10,
        platform_fee: 5,
        subtotal: 36,
        total_amount: 51,
        status: "DELIVERED",
        vendor: {
          image_url:
            "http://api.bibo.trangotechdevs.com:3012/1731923649651.octet-stream",
          slug: "21cd47e5-9a4c-4f32-93ad-dc6acc1653c2",
          firstname: null,
          lastname: null,
          name: "shop twelve",
          email: "shop12@yopmail.com",
          user_type: "SHOP_OWNER",
          latitude: "24.87790",
          longitude: "67.06860",
          mobile_no: "+11212121212",
        },
        user: {
          image_url:
            "http://api.bibo.trangotechdevs.com:3012/user-placeholder.jpeg",
          slug: "a19c9a6d-6468-4813-b667-15b3a863afa7",
          firstname: "customer",
          lastname: "thirteen",
          name: null,
          email: "customer13@yopmail.com",
          user_type: "CUSTOMER",
          latitude: null,
          longitude: null,
          mobile_no: "+12430434845",
        },
        rider: {
          image_url:
            "http://api.bibo.trangotechdevs.com:3012/user-placeholder.jpeg",
          slug: "4a0abdf8-b70e-40bf-8c6a-294919e902d9",
          firstname: "rider",
          lastname: "thirteen",
          name: null,
          email: "rider13@yopmail.com",
          user_type: "RIDER",
          latitude: "24.8779819",
          longitude: "67.0686884",
          mobile_no: "+13454310945",
        },
        order_items_count: 1,
        created_at: "2024-11-19T07:32:01.000Z",
      },
      {
        id: 67,
        slug: "d2e268aa-3a82-4dd5-9462-03e1fab55c41",
        rider_slug: "fad8063d-f6cf-4499-8dce-6c149efe89e8",
        user_slug: "eab95d2c-ff15-46c9-aec3-17d58da84151",
        vendor_slug: "21cd47e5-9a4c-4f32-93ad-dc6acc1653c2",
        owner_type: "CUSTOMER",
        delivery_location:
          "3rd Floor, Delhi Mercantile Society, Karachi, Sindh, , Pakistan, 3rd Floor, 6",
        latitude: "24.878",
        longitude: "67.0686",
        delivery_charges: 10,
        platform_fee: 5,
        subtotal: 11079,
        total_amount: 11094,
        status: "DELIVERED",
        vendor: {
          image_url:
            "http://api.bibo.trangotechdevs.com:3012/1731923649651.octet-stream",
          slug: "21cd47e5-9a4c-4f32-93ad-dc6acc1653c2",
          firstname: null,
          lastname: null,
          name: "shop twelve",
          email: "shop12@yopmail.com",
          user_type: "SHOP_OWNER",
          latitude: "24.87790",
          longitude: "67.06860",
          mobile_no: "+11212121212",
        },
        user: {
          image_url:
            "http://api.bibo.trangotechdevs.com:3012/user-placeholder.jpeg",
          slug: "eab95d2c-ff15-46c9-aec3-17d58da84151",
          firstname: "Gold",
          lastname: "Smith",
          name: null,
          email: "customer12@yopmail.com",
          user_type: "CUSTOMER",
          latitude: null,
          longitude: null,
          mobile_no: "+12486481218",
        },
        rider: {
          image_url:
            "http://api.bibo.trangotechdevs.com:3012/user-placeholder.jpeg",
          slug: "fad8063d-f6cf-4499-8dce-6c149efe89e8",
          firstname: "rider",
          lastname: "user",
          name: null,
          email: "rideruser@yopmail.com",
          user_type: "RIDER",
          latitude: "24.8780313",
          longitude: "67.0687139",
          mobile_no: "+11234567896",
        },
        order_items_count: 1,
        created_at: "2024-11-18T10:11:05.000Z",
      },
      {
        id: 66,
        slug: "fa5904c5-60d5-483f-b9b4-a0cd19a5198c",
        rider_slug: "fad8063d-f6cf-4499-8dce-6c149efe89e8",
        user_slug: "eab95d2c-ff15-46c9-aec3-17d58da84151",
        vendor_slug: "21cd47e5-9a4c-4f32-93ad-dc6acc1653c2",
        owner_type: "CUSTOMER",
        delivery_location:
          "3rd Floor, Delhi Mercantile Society, Karachi, Sindh, , Pakistan, 3rd Floor, 6",
        latitude: "24.878",
        longitude: "67.0686",
        delivery_charges: 10,
        platform_fee: 5,
        subtotal: 2462,
        total_amount: 2477,
        status: "READY_FOR_DELIVERY",
        vendor: {
          image_url:
            "http://api.bibo.trangotechdevs.com:3012/1731923649651.octet-stream",
          slug: "21cd47e5-9a4c-4f32-93ad-dc6acc1653c2",
          firstname: null,
          lastname: null,
          name: "shop twelve",
          email: "shop12@yopmail.com",
          user_type: "SHOP_OWNER",
          latitude: "24.87790",
          longitude: "67.06860",
          mobile_no: "+11212121212",
        },
        user: {
          image_url:
            "http://api.bibo.trangotechdevs.com:3012/user-placeholder.jpeg",
          slug: "eab95d2c-ff15-46c9-aec3-17d58da84151",
          firstname: "Gold",
          lastname: "Smith",
          name: null,
          email: "customer12@yopmail.com",
          user_type: "CUSTOMER",
          latitude: null,
          longitude: null,
          mobile_no: "+12486481218",
        },
        rider: {
          image_url:
            "http://api.bibo.trangotechdevs.com:3012/user-placeholder.jpeg",
          slug: "fad8063d-f6cf-4499-8dce-6c149efe89e8",
          firstname: "rider",
          lastname: "user",
          name: null,
          email: "rideruser@yopmail.com",
          user_type: "RIDER",
          latitude: "24.8780313",
          longitude: "67.0687139",
          mobile_no: "+11234567896",
        },
        order_items_count: 1,
        created_at: "2024-11-18T09:38:59.000Z",
      },
      {
        id: 65,
        slug: "b6cb9600-9144-40cb-a9bd-aaffd8ec9da0",
        rider_slug: "4a0abdf8-b70e-40bf-8c6a-294919e902d9",
        user_slug: "eab95d2c-ff15-46c9-aec3-17d58da84151",
        vendor_slug: "21cd47e5-9a4c-4f32-93ad-dc6acc1653c2",
        owner_type: "CUSTOMER",
        delivery_location:
          "3rd Floor, Delhi Mercantile Society, Karachi, Sindh, , Pakistan, 3rd Floor, 6",
        latitude: "24.878",
        longitude: "67.0686",
        delivery_charges: 10,
        platform_fee: 5,
        subtotal: 2462,
        total_amount: 2477,
        status: "RIDER_ACCEPTED",
        vendor: {
          image_url:
            "http://api.bibo.trangotechdevs.com:3012/1731923649651.octet-stream",
          slug: "21cd47e5-9a4c-4f32-93ad-dc6acc1653c2",
          firstname: null,
          lastname: null,
          name: "shop twelve",
          email: "shop12@yopmail.com",
          user_type: "SHOP_OWNER",
          latitude: "24.87790",
          longitude: "67.06860",
          mobile_no: "+11212121212",
        },
        user: {
          image_url:
            "http://api.bibo.trangotechdevs.com:3012/user-placeholder.jpeg",
          slug: "eab95d2c-ff15-46c9-aec3-17d58da84151",
          firstname: "Gold",
          lastname: "Smith",
          name: null,
          email: "customer12@yopmail.com",
          user_type: "CUSTOMER",
          latitude: null,
          longitude: null,
          mobile_no: "+12486481218",
        },
        rider: {
          image_url:
            "http://api.bibo.trangotechdevs.com:3012/user-placeholder.jpeg",
          slug: "4a0abdf8-b70e-40bf-8c6a-294919e902d9",
          firstname: "rider",
          lastname: "thirteen",
          name: null,
          email: "rider13@yopmail.com",
          user_type: "RIDER",
          latitude: "24.8779819",
          longitude: "67.0686884",
          mobile_no: "+13454310945",
        },
        order_items_count: 1,
        created_at: "2024-11-18T09:24:24.000Z",
      },
      {
        id: 64,
        slug: "ccbb8b68-0587-47bf-aa05-6bd67136c44b",
        rider_slug: "fad8063d-f6cf-4499-8dce-6c149efe89e8",
        user_slug: "eab95d2c-ff15-46c9-aec3-17d58da84151",
        vendor_slug: "21cd47e5-9a4c-4f32-93ad-dc6acc1653c2",
        owner_type: "CUSTOMER",
        delivery_location:
          "3rd Floor, Delhi Mercantile Society, Karachi, Sindh, , Pakistan, 3rd Floor, 6",
        latitude: "24.878",
        longitude: "67.0686",
        delivery_charges: 10,
        platform_fee: 5,
        subtotal: 1231,
        total_amount: 1246,
        status: "DELIVERED",
        vendor: {
          image_url:
            "http://api.bibo.trangotechdevs.com:3012/1731923649651.octet-stream",
          slug: "21cd47e5-9a4c-4f32-93ad-dc6acc1653c2",
          firstname: null,
          lastname: null,
          name: "shop twelve",
          email: "shop12@yopmail.com",
          user_type: "SHOP_OWNER",
          latitude: "24.87790",
          longitude: "67.06860",
          mobile_no: "+11212121212",
        },
        user: {
          image_url:
            "http://api.bibo.trangotechdevs.com:3012/user-placeholder.jpeg",
          slug: "eab95d2c-ff15-46c9-aec3-17d58da84151",
          firstname: "Gold",
          lastname: "Smith",
          name: null,
          email: "customer12@yopmail.com",
          user_type: "CUSTOMER",
          latitude: null,
          longitude: null,
          mobile_no: "+12486481218",
        },
        rider: {
          image_url:
            "http://api.bibo.trangotechdevs.com:3012/user-placeholder.jpeg",
          slug: "fad8063d-f6cf-4499-8dce-6c149efe89e8",
          firstname: "rider",
          lastname: "user",
          name: null,
          email: "rideruser@yopmail.com",
          user_type: "RIDER",
          latitude: "24.8780313",
          longitude: "67.0687139",
          mobile_no: "+11234567896",
        },
        order_items_count: 1,
        created_at: "2024-11-18T04:54:45.000Z",
      },
      {
        id: 63,
        slug: "9b715cb8-94a8-4394-9a97-f39771e4ad18",
        rider_slug: null,
        user_slug: "eab95d2c-ff15-46c9-aec3-17d58da84151",
        vendor_slug: "21cd47e5-9a4c-4f32-93ad-dc6acc1653c2",
        owner_type: "CUSTOMER",
        delivery_location:
          "3rd Floor, Delhi Mercantile Society, Karachi, Sindh, , Pakistan, 3rd Floor, 6",
        latitude: "24.878",
        longitude: "67.0686",
        delivery_charges: 10,
        platform_fee: 5,
        subtotal: 1231,
        total_amount: 1246,
        status: "COMPLETED",
        vendor: {
          image_url:
            "http://api.bibo.trangotechdevs.com:3012/1731923649651.octet-stream",
          slug: "21cd47e5-9a4c-4f32-93ad-dc6acc1653c2",
          firstname: null,
          lastname: null,
          name: "shop twelve",
          email: "shop12@yopmail.com",
          user_type: "SHOP_OWNER",
          latitude: "24.87790",
          longitude: "67.06860",
          mobile_no: "+11212121212",
        },
        user: {
          image_url:
            "http://api.bibo.trangotechdevs.com:3012/user-placeholder.jpeg",
          slug: "eab95d2c-ff15-46c9-aec3-17d58da84151",
          firstname: "Gold",
          lastname: "Smith",
          name: null,
          email: "customer12@yopmail.com",
          user_type: "CUSTOMER",
          latitude: null,
          longitude: null,
          mobile_no: "+12486481218",
        },
        rider: null,
        order_items_count: 1,
        created_at: "2024-11-18T04:52:22.000Z",
      },
      {
        id: 62,
        slug: "479390f8-ddb6-4f0b-ba67-38b1c91b6443",
        rider_slug: "fad8063d-f6cf-4499-8dce-6c149efe89e8",
        user_slug: "36230b8f-1e57-4d52-b2e6-e824810f8807",
        vendor_slug: "45e4870b-54fc-431e-86cd-50c2a184c841",
        owner_type: "CUSTOMER",
        delivery_location:
          "3rd Floor, Delhi Mercantile Society, Karachi, Sindh, , Pakistan, 3rd Floor, 2 floor",
        latitude: "24.878",
        longitude: "67.0686",
        delivery_charges: 10,
        platform_fee: 5,
        subtotal: 110,
        total_amount: 125,
        status: "PENDING_APPROVAL",
        vendor: {
          image_url:
            "http://api.bibo.trangotechdevs.com:3012/1720778914354.octet-stream",
          slug: "45e4870b-54fc-431e-86cd-50c2a184c841",
          firstname: null,
          lastname: null,
          name: "shop1",
          email: "shop1@yopmail.com",
          user_type: "SHOP_OWNER",
          latitude: "24.882087",
          longitude: "67.071337",
          mobile_no: "+11234567897",
        },
        user: {
          image_url:
            "http://api.bibo.trangotechdevs.com:3012/user-placeholder.jpeg",
          slug: "36230b8f-1e57-4d52-b2e6-e824810f8807",
          firstname: "customer",
          lastname: "one",
          name: null,
          email: "customer1@yopmail.com",
          user_type: "CUSTOMER",
          latitude: null,
          longitude: null,
          mobile_no: "+11234657971",
        },
        rider: {
          image_url:
            "http://api.bibo.trangotechdevs.com:3012/user-placeholder.jpeg",
          slug: "fad8063d-f6cf-4499-8dce-6c149efe89e8",
          firstname: "rider",
          lastname: "user",
          name: null,
          email: "rideruser@yopmail.com",
          user_type: "RIDER",
          latitude: "24.8780313",
          longitude: "67.0687139",
          mobile_no: "+11234567896",
        },
        order_items_count: 1,
        created_at: "2024-11-15T14:46:31.000Z",
      },
      {
        id: 61,
        slug: "28bcde81-e088-4619-9298-fa69363e1121",
        rider_slug: "fad8063d-f6cf-4499-8dce-6c149efe89e8",
        user_slug: "36230b8f-1e57-4d52-b2e6-e824810f8807",
        vendor_slug: "45e4870b-54fc-431e-86cd-50c2a184c841",
        owner_type: "CUSTOMER",
        delivery_location:
          "3rd Floor, Delhi Mercantile Society, Karachi, Sindh, , Pakistan, 3rd Floor, 2 floor",
        latitude: "24.878",
        longitude: "67.0686",
        delivery_charges: 10,
        platform_fee: 5,
        subtotal: 110,
        total_amount: 125,
        status: "DELIVERED",
        vendor: {
          image_url:
            "http://api.bibo.trangotechdevs.com:3012/1720778914354.octet-stream",
          slug: "45e4870b-54fc-431e-86cd-50c2a184c841",
          firstname: null,
          lastname: null,
          name: "shop1",
          email: "shop1@yopmail.com",
          user_type: "SHOP_OWNER",
          latitude: "24.882087",
          longitude: "67.071337",
          mobile_no: "+11234567897",
        },
        user: {
          image_url:
            "http://api.bibo.trangotechdevs.com:3012/user-placeholder.jpeg",
          slug: "36230b8f-1e57-4d52-b2e6-e824810f8807",
          firstname: "customer",
          lastname: "one",
          name: null,
          email: "customer1@yopmail.com",
          user_type: "CUSTOMER",
          latitude: null,
          longitude: null,
          mobile_no: "+11234657971",
        },
        rider: {
          image_url:
            "http://api.bibo.trangotechdevs.com:3012/user-placeholder.jpeg",
          slug: "fad8063d-f6cf-4499-8dce-6c149efe89e8",
          firstname: "rider",
          lastname: "user",
          name: null,
          email: "rideruser@yopmail.com",
          user_type: "RIDER",
          latitude: "24.8780313",
          longitude: "67.0687139",
          mobile_no: "+11234567896",
        },
        order_items_count: 1,
        created_at: "2024-11-15T14:21:26.000Z",
      },
    ],
    links: {
      total: 2,
      per_page: 10,
      current: 1,
      prev: 0,
      next: 2,
      total_records: 19,
    },
  };

  const filterData = [
    {
      value: "all",
      label: "All",
    },
    {
      value: 0,
      label: "Active",
    },
    {
      value: 1,
      label: "InActive",
    },
  ];

  const { data, isSuccess, isLoading, isFetching, refetch } =
    useGetAllQuestionQuery(
      {
        search: searchQuery.length >= 3 ? searchQuery : "",
        limit: pageSize,
        page: currentPage,
        // ...(status && status === "all"
        //   ? { is_blocked: "" }
        //   : { is_blocked: status === undefined ? "" : status }),
      },
      { refetchOnMountOrArgChange: true }
    );

  useEffect(() => {
    if (data) {
      // console.log(data);
      setPageSize(data.links.per_page);
      setCurrentPage(data.links.current);
      setTotalRecords(data.links.total_records);
      setTotalPages(data.links.total);
      setRowData(data.data);
      setDataFetched(true);
    }
  }, [data]);

  // const debouncedSearch = useCallback(
  //   debounce((query) => {
  //     console.log("Search query:", query);
  //     // local search logic
  //     const filtered = dummy_data.filter((item) =>
  //       [item.firstname, item.lastname, item.username, item.email]
  //         .filter(Boolean) // Remove null/undefined fields
  //         .some((field) => field.toLowerCase().includes(query.toLowerCase()))
  //     );

  //     setRowData(filtered);

  //     // Trigger your search logic or API here
  //   }, 500), // Adjust debounce delay as needed
  //   []
  // );

  const handleSearchChange = (event) => {
    const query = event.target.value;
    // console.log("Search query:", query); // You can use this to trigger a search function
    setSearchQuery(query);

    // debouncedSearch(query);
  };

  const handleDeleteModalOpen = () => {
    setDeleteModal(true);
  };

  const handleDeleteModalClose = () => {
    setDeleteModal(false);
    setEditedData("");
  };

  const handleEditModalOpen = () => {
    setEditModal(true);
  };

  const handleEditModalClose = () => {
    setEditModal(false);
    setEditedData("");
  };

  const handleAddUser = () => {
    setEditModal(true);
  };

  const [deleteQuestion, { isLoading: isDeleting }] =
    useDeleteQuestionMutation();

  const deleteData = async (slug) => {
    try {
      const { data } = await deleteQuestion(slug);
      // console.log(data);
      if (data.code === 200) {
        await refetch();
        handleDeleteModalClose();
        SuccessToast(data.message);
      }
    } catch (error) {
      // console.log(error);
      Toast(error.message, "error");
    }
  };

  function indication() {
    // return something here
    // return 'Table is empty';
    return indicationMessage;
  }

  const columns = [
    {
      dataField: "id",
      text: "Order Id",
      headerAlign: "center",
      align: "center",
      sort: true,
      headerStyle: {
        width: "100px",
      },
      // formatter: (cellContent, row) => {
      //   return <UserAvatar username={cellContent} image_url={row.image_url} />;
      // },
    },
    {
      dataField: "user",
      text: "Customer Name",
      headerAlign: "center",
      align: "center",
      sort: true,
      headerStyle: {
        width: "200px",
      },
      formatter: (cellContent, row) => {
        return (
          <UserAvatar
            username={`${row?.user?.firstname} ${row?.user?.lastname}`}
            image_url={row?.user?.image_url}
          />
        );
      },
    },
    {
      dataField: "created_at",
      text: "Date",
      headerAlign: "center",
      align: "center",
      sort: true,
      headerStyle: {
        // width: "200px",
      },
      formatter: (cellContent, row) => {
        return moment(cellContent).format("DD/MM/YYYY");
      },
    },
    {
      dataField: "order_items_count",
      text: "Items",
      headerAlign: "center",
      align: "center",
      sort: true,
      headerStyle: {
        // width: "200px",
      },
    },
    {
      dataField: "delivery_charges",
      text: "DC",
      headerAlign: "center",
      align: "center",
      sort: true,
      headerStyle: {
        // width: "200px",
      },
    },
    {
      dataField: "total_amount",
      text: "Amout",
      headerAlign: "center",
      align: "center",
      sort: true,
      headerStyle: {
        // width: "200px",
      },
    },
    {
      dataField: "status",
      text: "Status",
      headerAlign: "center",
      align: "center",
      sort: true,
      headerStyle: {
        // width: "200px",
      },
      formatter: (cellContent, row) => {
        return <CustomBadge text={cellContent} />;
      },
    },
    {
      dataField: "actions",
      text: "Actions",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "200px",
      },
      formatter: (cellContent, row) => {
        // console.log(row)
        if (row.slug || row.id) {
          return (
            <div className="d-flex justify-content-center align-items-center ">
              <ToolTip placement={"top"} content={"Details"}>
                <div
                  className={` d-flex justify-content-center align-items-center bg-primary-hover rounded-3 mx-2 p-2`}
                  role="button"
                  onClick={() => {
                    setEditedData(row);
                    handleEditModalOpen(true);
                  }}
                >
                  <span
                    className={`align-items-center d-flex justify-content-center`}
                  >
                    <CgDetailsMore />
                  </span>
                  {/* <span>Edit</span> */}
                </div>
              </ToolTip>

              {/* <ToolTip placement={"top"} content={"Delete"}>
                <div
                  className="d-flex justify-content-center align-items-center bg-danger-hover rounded-3 p-2 mx-2 "
                  role="button"
                  onClick={() => {
                    setEditedData(row);
                    handleDeleteModalOpen();
                  }}
                >
                  <span className={`d-flex align-items-center`}>
                    <MdDeleteForever />
                  </span>
                </div>
              </ToolTip> */}
            </div>
          );
        }
      },
    },
  ];

  return (
    <div className={styles.MainContainer}>
      {deleteModal ? (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <DeleteModal
            handleDeleteModalClose={handleDeleteModalClose}
            data={editedData}
            isDeleting={isDeleting}
            onDelete={deleteData}
          />
        </Suspense>
      ) : (
        ""
      )}

      {editModal ? (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <OrderDetailsModal
            handleEditModalClose={handleEditModalClose}
            editData={editedData}
            refetch={refetch}
          />
        </Suspense>
      ) : (
        ""
      )}

      <div className={styles.headerContainer}>
        <Row className="w-100 align-items-center">
          <Col md={6}>
            <div>
              <SubTitle text={"Product Management"} classes="text-black" />
            </div>
          </Col>

          <Col md={6}>
            <div className="d-flex align-items-center gap-2 ms-auto">
              <Input
                placeholder="Search by name"
                value={searchQuery}
                onChange={handleSearchChange}
              />
              <Controller
                control={control}
                name="status"
                render={({ field: { onChange, value } }) => (
                  <SelectFieldComponent
                    firstOption={_.isEmpty(value) ? "Select Status" : value}
                    optionsList={filterData}
                    onSelectChange={onChange}
                  />
                )}
              />
            </div>
          </Col>
        </Row>

        {/* {
          <Row>
            <Col md={12}>
              <Button
                classes={`${styles.cardBtn} `}
                text="Add Question"
                onClick={handleAddUser}
              ></Button>
            </Col>
          </Row>
        } */}
      </div>

      <div className={styles.mainTable}>
        {/* {!dataFetched || isLoading ? (
          <CustomLoader />
        ) : ( */}
        <div className={styles.mainTable}>
          {
            <Table
              // classes={`${dataFetched && isFetching ? "blur-table" : ""}`}
              data={dummyData.data || rowData || []}
              columns={columns}
              indication={indication}
              totalRecords={totalRecords} // todo
              totalPages={totalPages} // todo
              pageSize={pageSize} // todo
              currentPage={currentPage} // todo
              setCurrentPage={setCurrentPage} // todo
              setPageSize={setPageSize} // todo
              // refetch={refetch} // todo
              refetch={() => {}} // todo
            />
          }
        </div>
        {/* )} */}
      </div>
    </div>
  );
};

export default ProductManagementScreen;
